
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiktok-ads-analytics",
      function () {
        return require("private-next-pages/tiktok-ads-analytics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiktok-ads-analytics"])
      });
    }
  